// @ts-nocheck

import de from './de.png';
import en from './en.png';
import es from './es.png';
import fr from './fr.png';

export default {
  fr,
  en,
  de,
  es,
};
